import type {IHouse, IApartment} from './api';
import {getNested} from './api';
interface n {
  [key: string]: any;
}
import Logger from "~/helpers/logger";

const logger = Logger.getInstance();

export const getApartamentsForHouse = async (uuid: string) => {
  const res = await getNested('apartment', 'house', uuid);
  if (res.status === 'OK') {
    logger.info(`[API] success getApartamentsForHouse(): ${JSON.stringify(res.data)}`);
    return res.data;
  }
  logger.info(`[API] return [] getApartamentsForHouse()`);
  return [];
};

export const getApartamentsForRealty = async (uuid: string) => {
  if (!uuid) {
    logger.info(`[API] return [] cause UUID getApartamentsForRealty()`);
    return [];
  }
  const res = await getNested('apartment', 'real_estate', uuid);
  if (res.status === 'OK') {
    logger.info(`[API] success getApartamentsForRealty(): ${JSON.stringify(res.data)}`);
    return res.data;
  }
  logger.info(`[API] return [] getApartamentsForRealty()`);
  return [];
};

export const getApartamentsForFloor = async (uuid: string) => {
  const res = await getNested('apartment', 'floor', uuid);
  if (res.status === 'OK') {
    logger.info(`[API] success getApartamentsForFloor(): ${JSON.stringify(res.data)}`);
    return res.data;
  }
  logger.info(`[API] return [] getApartamentsForFloor()`);
  return [];
};

export async function getPlans(uuid: string) {
  const res = await getNested('plan', 'entrance', uuid);
  if (res.status === 'OK') {
    logger.info(`[API] success getPlans(): ${JSON.stringify(res.data)}`);
    return res.data;
  }
  logger.info(`[API] return [] getPlans()`);
  return [];
}

export async function getFloors(uuid: string) {
  const res = await getNested('floor', 'plan', uuid);
  if (res.status === 'OK') {
    logger.info(`[API] success getFloors(): ${JSON.stringify(res.data)}`);
    return res.data ? res.data : [];
  }
  logger.info(`[API] return [] getFloors()`);
  return [];
}

export async function getEntrances(uuid: string) {
  const entrances = [];
  const res = await getNested('entrance', 'house', uuid);
  // console.debug({res:res.data})
  if (res.status === 'OK') {
    await Promise.all(
      res.data.map(async (entrance) => {
        const object = {...entrance};
        const plans_data: any = [];

        const plans = await getPlans(entrance.uuid);

        if (plans) {
          await Promise.all(
            plans.map(async (plan) => {
              const floor_data = await getFloors(plan.uuid);
              const floors: any[] = [];
              // await Promise.all(
              //   floor_data.map(async (floor) => {
              //     const apartment = await getApartamentsForFloor(
              //       floor.uuid,
              //     );
              //     floor.apartments = apartment ? apartment : [];
              //     floors.push(floor);
              //   }),
              // );

              plan.floors = floor_data;
              plans_data.push(plan);
            }),
          );
        }

        object.plans = plans ? plans_data : [];
        entrances.push(object);
      }),
    );
    const compareByName = (a: {name: string}, b: {name: string}) => {
      const nameA = parseInt(a.name, 10);
      const nameB = parseInt(b.name, 10);

      return nameA - nameB;
    };
    entrances.sort(compareByName);
    logger.info(`[API] success getEntrances(): ${entrances}`);
    return entrances;
  }
  logger.info(`[API] return [] getEntrances()`);
  return [];
}

export async function getApartments(uuid: string) {
  const haveAppartments = false;
  const haveEntrances = false;
  if (!uuid) {
    logger.info(`[API] return [] cause UUID getApartments()`);
    return [];
  }
  const res = await getNested('apartment', 'real_estate', uuid);
  if (res.status === 'OK') {
    logger.info(`[API] success getNested() ${JSON.stringify(res.data)}`);
    return {haveAppartments, haveEntrances, apartments: res.data};
  } else {
    logger.info(`[API] return apartments:[] getApartments()`);
    return {haveAppartments, haveEntrances, apartments: []};
  }
}

export async function getHouses(uuid: string) {
  const houses: IHouse[] = [];
  if (!uuid) {
    logger.info(`[API] return [] cause UUID getHouses()`);
    return [];
  }
  const res = await getNested('house', 'real_estate', uuid);

  if (res.status === 'OK') {
    logger.info(`[API] success getHouses() ${JSON.stringify(res.data)}`);
    return res.data as IHouse[];
  } else {
    logger.info(`[API] return [] getHouses()`);
    return houses;
  }
}

let obj: {[key: string]: IApartment[]} = {};

export function memoizeApartment(
  uuid: string,
  data: IApartment[],
): IApartment[] {
  if (obj[uuid]) {
    return obj[uuid];
  } else {
    obj[uuid] = data;
  }
  return data;
}

export function getMemoizeApartment(uuid: string): IApartment[] {
  if (obj[uuid]) {
    return obj[uuid];
  } else {
    return [];
  }
}

export function clearMemoizeApartment() {
  obj = {};
}
